import React, { memo } from 'react';
import { ListItem as MuiListItem, ListItemButton, ListItemIcon, ListItemText, Checkbox, } from '@mui/material';
var ListItem = function (props) {
    var value = props.value, onClick = props.onClick, checked = props.checked;
    return (React.createElement(MuiListItem, { disablePadding: true, key: 'listitem' + value.value },
        React.createElement(ListItemButton, { disableRipple: true, onClick: function () {
                onClick(value);
            } },
            React.createElement(ListItemIcon, null,
                React.createElement(Checkbox, { disableRipple: true, checked: checked })),
            React.createElement(ListItemText, null, value.label))));
};
export default memo(ListItem, function (next, prev) { return next.checked === prev.checked; });
